import { Image } from 'antd';

import { ColorModel } from '@common/models';
import { COMING_SOON_IMAGE, setDefaultSrc } from '@common/utils';
import ImageUtils from '@core/utils/ImageUtils';

import './image-viewer.scss';

export const getImageSource = (selectedColor: ColorModel, defaultUrl: string): string => {
    return selectedColor.beautyShotImageUrl ? selectedColor.beautyShotImageUrl : defaultUrl;
};

interface ImageViewerProps {
    selectedColor?: ColorModel;
    className?: 'image-viewer' | 'image-viewer--thumbnail' | 'image-viewer--thumbnail-hidden';
}

const ImageViewer = ({ className, selectedColor }: ImageViewerProps): JSX.Element => {
    return selectedColor ? (
        <Image
            className={className ?? 'image-viewer--thumbnail'}
            preview={false}
            src={ImageUtils.imgUrl(getImageSource(selectedColor, COMING_SOON_IMAGE), 400)}
            onError={setDefaultSrc}
        />
    ) : (
        <figure className="image-viewer--thumbnail-hidden" />
    );
};

export default ImageViewer;
